// cart-custom.js
document.addEventListener('DOMContentLoaded', function() {
  function formatMoney(cents) {
    // Shopify Money format: use server formatting if needed; simple fallback:
    return (cents/100).toLocaleString(undefined, {style:'currency', currency: '{{ shop.currency }}' || 'USD'});
  }

  // update cart totals UI from /cart.js
  function refreshCartUI() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // update subtotal/total
        const subtotalEl = document.getElementById('cw-subtotal');
        const totalEl = document.getElementById('cw-total');
        if (subtotalEl) subtotalEl.textContent = (cart.total_price/100).toLocaleString(undefined, {style:'currency', currency: cart.currency || '{{ shop.currency }}'});
        if (totalEl) totalEl.textContent = (cart.total_price/100).toLocaleString(undefined, {style:'currency', currency: cart.currency || '{{ shop.currency }}'});

        // update list item prices
        cart.items.forEach(function(item, idx) {
          const line = idx + 1;
          const priceEl = document.querySelector('.cw-item[data-line="'+line+'"] .cw-price');
          const qtyInput = document.querySelector('.cw-item[data-line="'+line+'"] .cw-qty-input');
          if (priceEl) priceEl.textContent = (item.final_line_price/100).toLocaleString(undefined, {style:'currency', currency: cart.currency || '{{ shop.currency }}'});
          if (qtyInput) qtyInput.value = item.quantity;
        });

        // update mini-cart list
        const miniPrices = document.querySelectorAll('.cw-mini-price');
        cart.items.slice(0,2).forEach(function(item, i){
          if (miniPrices[i]) miniPrices[i].textContent = (item.final_line_price/100).toLocaleString(undefined, {style:'currency', currency: cart.currency || '{{ shop.currency }}'});
        });
      });
  }

  // change quantity function
  function changeQuantity(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    })
    .then(r => r.json())
    .then(cart => {
      refreshCartUI();
    });
  }

  // attach events to + / - and inputs
  document.body.addEventListener('click', function(e){
    if (e.target.matches('.cw-increase') || e.target.matches('.cw-decrease')) {
      const line = e.target.getAttribute('data-line');
      const input = document.querySelector('.cw-item[data-line="'+line+'"] .cw-qty-input');
      if (!input) return;
      let val = parseInt(input.value,10) || 0;
      if (e.target.matches('.cw-increase')) val++;
      if (e.target.matches('.cw-decrease')) val = Math.max(0, val-1);
      changeQuantity(line, val);
    }

    if (e.target.id === 'cw-apply-discount') {
      const code = document.getElementById('cw-discount').value.trim();
      if (!code) return alert('Please enter a code');
      // apply discount via redirect to ?discount=CODE
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }
  });

  // input manual change
  document.body.addEventListener('change', function(e){
    if (e.target.matches('.cw-qty-input')) {
      const line = e.target.getAttribute('data-line');
      let val = parseInt(e.target.value,10) || 0;
      changeQuantity(line, val);
    }
  });

  // initial refresh
  refreshCartUI();
});
